import React from 'react'
import { Container, Copy, Box, RichText, MOBILE, DESKTOP } from 'chemistry'
import { parseSeoCategoryInfo, parseCfSeoCategoryInfo } from './parseSeoCategoryInfo'
import SocialMediaEmbed from './socialMediaEmbed'

const marginBottom = { mb: '16px' }
const richTextStyles = ['h2', 'h1', 'h3', 'h4', 'h5', 'h6', 'p'].reduce((acc, curr) => {
  acc[curr] = marginBottom
  return acc
}, {})

const gtmClassNameSelector = 'seoText'
const GtmSeoWrapper = props => (
  <Box
    className={gtmClassNameSelector} // is needed as a selector for GTM script to insert a disclaimer
    {...props}
  />
)

const SeoWidgetContainer = ({ categoryInfo, categoryCfInfo }) => {
  if (categoryCfInfo) {
    const { embedList, mobileSpecificEmbedList, ...rest } = parseCfSeoCategoryInfo(categoryCfInfo)

    return (
      <GtmSeoWrapper>
        <Container
          sx={{
            padding: 0,
            [DESKTOP]: {
              width: '100%'
            }
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Box
              sx={{
                maxWidth: '800px',
                width: '100%'
              }}
            >
              <Copy id='seoInfo' {...rest} title={null} />
              {!!embedList.length && (
                <Box
                  sx={{
                    [MOBILE]: {
                      display: mobileSpecificEmbedList.length ? 'none' : 'block'
                    }
                  }}
                >
                  <SocialMediaEmbed
                    embedList={embedList}
                    isTopSpace={rest.defaultJson.content.length > embedList.length}
                  />
                </Box>
              )}
              {!!mobileSpecificEmbedList.length && (
                <Box sx={{ [DESKTOP]: { display: 'none' } }}>
                  <SocialMediaEmbed
                    embedList={mobileSpecificEmbedList}
                    isTopSpace={rest.mobileSpecificJson.content.length > mobileSpecificEmbedList.length}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Container>
      </GtmSeoWrapper>
    )
  }

  const parsedCategoryInfo = parseSeoCategoryInfo(categoryInfo)
  return (
    <GtmSeoWrapper mt='16px'>
      {parsedCategoryInfo && <RichText id='soft-content-text' json={parsedCategoryInfo} {...richTextStyles} />}
    </GtmSeoWrapper>
  )
}

export default React.memo(SeoWidgetContainer)
